module.exports = __webpack_public_path__ + "assets/icon_bonus.b845c26c.svg";